import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './RecordIcon.module.css';
import ImageWithFallback from '../GenericComponents/ImageWithFallback';
import { getImages } from '../Result/getImages';

interface RecordIconProps {
  record: any;
  index: number;
  handleLinkClick: (event: React.MouseEvent, index: number) => void;
}

const RecordIcon: React.FC<RecordIconProps> = ({ record, index, handleLinkClick }) => {
  const { t } = useTranslation();
  const [isHovered, setIsHovered] = useState(false);
  let imageUrl = `${process.env.REACT_APP_IMAGE_BASE_URL}/nondisponible.cci&width=240&height=160&bg=ffffff`; //todo: noimage
  const allImages = getImages(record);
  if ((allImages as any)["icon"]?.length > 0) {
      imageUrl = (allImages as any)["icon"][0]?.url;
  }
  //console.log(imageUrl)
  const invNo = record?.data?.Record?.ObjectNumber;

  function getTitle(record: any) {
    const titleData = record?.data?.record?.title?.title;
    const objectNrData = record?.data?.record?.objectnumber;

    if (!titleData) return <div className={styles.row}>{t('No title')}</div>;

    return (
      <div className={styles.row}>
        {titleData}
        <br />
        {objectNrData}
      </div>
    );
  }

  return (
    <a
      href={`${window.location.pathname}?action=search&field=/Record/ObjectNumber&label=N°%20de%20gestion&value=${invNo}`}
      className={styles.RecordIcon}
      key={index}
      onClick={(event) => handleLinkClick(event, index)}
      onMouseDown={e => e.preventDefault()}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className={styles.iconViewRecord}>
        {imageUrl && <ImageWithFallback src={imageUrl} alt="Image" placeholder={`${process.env.REACT_APP_IMAGE_BASE_URL}/nondisponible.cci&width=240&height=160`} />}
        {isHovered && (
          <div className={styles.hoverOverlay}>
            <div className={styles.title}>{getTitle(record)}</div>
            {record?.data?.Record?.Country && (
              <>
                <div className={styles.staticText}>{t("record_country")}</div>
                {Array.isArray(record?.data?.Record?.Country)
                  ? record?.data?.Record?.Country[0]?.Term ?? ''
                  : record?.data?.Record?.Country?.Term ?? ''
                }
              </>
            )}
          </div>
        )}
      </div>
    </a>
  );
};

export default RecordIcon;
